<template>
  <div class="personnel-duty-container">
    <!-- Hero Header Section -->
    <v-card class="hero-header mb-6" elevation="0">
      <div class="hero-content">
        <div class="hero-icon-wrapper">
          <v-icon size="48" color="white">mdi-clipboard-check-outline</v-icon>
        </div>
        <div class="hero-text">
          <h1 class="hero-title">การปฏิบัติหน้าที่ในวิชาเอก</h1>
          <p class="hero-subtitle">1.2 การจัดการเรียนการสอน / ผู้บังคับบัญชามอบหมาย</p>
        </div>
        <v-spacer></v-spacer>
        <v-btn class="add-btn" large depressed @click="personnel_dutyAdd()">
          <v-icon left>mdi-plus</v-icon>
          เพิ่มรายการ
        </v-btn>
      </div>
    </v-card>

    <!-- Statistics Cards -->
    <v-row class="stats-row mb-6">
      <v-col cols="12" sm="6" md="3">
        <v-card class="stat-card stat-card-1" elevation="0">
          <div class="stat-icon">
            <v-icon color="white" size="28">mdi-file-document-multiple</v-icon>
          </div>
          <div class="stat-content">
            <span class="stat-number">{{ personnel_dutys.length }}</span>
            <span class="stat-label">รายการทั้งหมด</span>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="stat-card stat-card-2" elevation="0">
          <div class="stat-icon">
            <v-icon color="white" size="28">mdi-calendar-check</v-icon>
          </div>
          <div class="stat-content">
            <span class="stat-number">{{ countCurrentYear }}</span>
            <span class="stat-label">ปีปัจจุบัน</span>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="stat-card stat-card-3" elevation="0">
          <div class="stat-icon">
            <v-icon color="white" size="28">mdi-school</v-icon>
          </div>
          <div class="stat-content">
            <span class="stat-number">{{ uniqueColleges }}</span>
            <span class="stat-label">สถานศึกษา</span>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="stat-card stat-card-4" elevation="0">
          <div class="stat-icon">
            <v-icon color="white" size="28">mdi-chart-timeline-variant</v-icon>
          </div>
          <div class="stat-content">
            <span class="stat-number">{{ uniqueYears }}</span>
            <span class="stat-label">จำนวนปี</span>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Main Data Table Card -->
    <v-card class="main-table-card" elevation="0">
      <v-card-title class="table-header">
        <div class="header-left">
          <v-icon class="mr-3" color="#dc2626">mdi-format-list-checkbox</v-icon>
          <span class="header-title">รายการปฏิบัติหน้าที่</span>
        </div>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="ค้นหารายการ..."
          single-line
          hide-details
          dense
          outlined
          class="search-field"
          style="max-width: 350px"
        ></v-text-field>
      </v-card-title>

      <v-divider></v-divider>

      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="personnel_dutys"
        :search="search"
        :items-per-page="10"
        class="modern-table"
        loading-text="กำลังโหลดข้อมูล..."
        no-data-text="ไม่พบข้อมูลการปฏิบัติหน้าที่"
        no-results-text="ไม่พบผลลัพธ์ที่ค้นหา"
      >
        <template v-slot:item="{ item, index }">
          <tr class="table-row">
            <td class="text-center">
              <v-avatar size="32" color="#dc2626" class="white--text font-weight-bold">
                {{ index + 1 }}
              </v-avatar>
            </td>
            <td>
              <div class="college-cell">
                <v-icon small color="#a86400" class="mr-2">mdi-domain</v-icon>
                <span>{{ item.college_name }}</span>
              </div>
            </td>
            <td class="text-center">
              <v-chip small color="#fef2f2" text-color="#dc2626" class="year-chip">
                <v-icon left small>mdi-calendar</v-icon>
                {{ item.personnel_dutyYear }}
              </v-chip>
            </td>
            <td>
              <v-chip small outlined color="#455a64" class="order-chip">
                <v-icon left small>mdi-file-sign</v-icon>
                {{ item.personnel_dutyOrderID }}
              </v-chip>
            </td>
            <td>
              <div class="topic-cell">
                <span class="topic-text">{{ item.personnel_dutyTopic }}</span>
              </div>
            </td>
            <td class="text-center">
              <v-chip small color="#e8f5e9" text-color="#2e7d32">
                <v-icon left small>mdi-calendar-clock</v-icon>
                {{ item.personnel_dutyDateTime | moment("add", "543 years") | moment("D MMM YYYY") }}
              </v-chip>
            </td>
            <td class="text-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    class="action-btn edit-btn mr-1"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="personnel_dutyEdit(item.personnel_dutyID)"
                  >
                    <v-icon small>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>แก้ไข</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    class="action-btn delete-btn"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="personnel_dutyDelete(item.personnel_dutyID)"
                  >
                    <v-icon small>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>ลบ</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <!-- Add Duty Dialog -->
    <v-dialog
      v-model="addpersonnel_dutydialog"
      persistent
      max-width="650px"
      content-class="modern-dialog"
    >
      <v-card class="dialog-card">
        <v-card-title class="dialog-header add-header">
          <v-icon class="mr-3" color="white" size="28">mdi-plus-circle-outline</v-icon>
          <span>เพิ่มรายการปฏิบัติหน้าที่</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="addpersonnel_dutydialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="dialog-content">
          <v-form ref="addpersonnel_dutyform" lazy-validation>
            <!-- Section: ข้อมูลคำสั่ง -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="#dc2626" class="mr-2">mdi-file-document-outline</v-icon>
                ข้อมูลคำสั่ง
              </div>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="addpersonnel_duty.personnel_dutyYear"
                    label="ปี พ.ศ."
                    placeholder="เช่น 2567"
                    type="number"
                    :rules="[
                      v => !!v || 'กรุณาระบุปี',
                      v => (v && String(v).length === 4) || 'ปีต้องเป็นตัวเลข 4 หลัก'
                    ]"
                    outlined
                    dense
                    prepend-inner-icon="mdi-calendar"
                    class="modern-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="addpersonnel_duty.personnel_dutyOrderID"
                    label="เลขที่คำสั่ง"
                    placeholder="เช่น 888/2567"
                    :rules="[v => !!v || 'กรุณาระบุเลขที่คำสั่ง']"
                    outlined
                    dense
                    prepend-inner-icon="mdi-file-sign"
                    class="modern-input"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>

            <!-- Section: รายละเอียด -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="#a86400" class="mr-2">mdi-text-box-outline</v-icon>
                รายละเอียดโครงการ/กิจกรรม
              </div>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="addpersonnel_duty.personnel_dutyTopic"
                    label="ชื่อโครงการ/กิจกรรมในสถานศึกษา"
                    placeholder="ระบุชื่อโครงการหรือกิจกรรมที่ได้รับมอบหมาย"
                    :rules="[v => !!v || 'กรุณาระบุชื่อโครงการ/กิจกรรม']"
                    outlined
                    rows="3"
                    auto-grow
                    prepend-inner-icon="mdi-text"
                    class="modern-input"
                  ></v-textarea>
                </v-col>
              </v-row>
            </div>

            <!-- Section: วันที่ -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="#2e7d32" class="mr-2">mdi-calendar-range</v-icon>
                วันที่ดำเนินการ
              </div>
              <v-row>
                <v-col cols="12">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="addpersonnel_duty.personnel_dutyDateTime"
                        label="วันที่เริ่มดำเนินการ"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        class="modern-input"
                        hint="คลิกเพื่อเลือกวันที่"
                        persistent-hint
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="addpersonnel_duty.personnel_dutyDateTime"
                      no-title
                      scrollable
                      locale="th-TH"
                      color="#dc2626"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="grey" @click="menu = false">ยกเลิก</v-btn>
                      <v-btn text color="#dc2626" @click="$refs.menu.save(date)">ตกลง</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </div>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text large @click="addpersonnel_dutydialog = false" class="cancel-btn">
            <v-icon left>mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            large
            depressed
            color="#dc2626"
            dark
            @click="addpersonnel_dutySubmit()"
            class="save-btn"
          >
            <v-icon left>mdi-content-save-outline</v-icon>
            บันทึกข้อมูล
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Edit Duty Dialog -->
    <v-dialog
      v-model="editpersonnel_dutydialog"
      persistent
      max-width="650px"
      content-class="modern-dialog"
    >
      <v-card class="dialog-card">
        <v-card-title class="dialog-header edit-header">
          <v-icon class="mr-3" color="white" size="28">mdi-pencil-outline</v-icon>
          <span>แก้ไขรายการปฏิบัติหน้าที่</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="editpersonnel_dutydialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="dialog-content">
          <v-form ref="editpersonnel_dutyform" lazy-validation>
            <!-- Section: ข้อมูลคำสั่ง -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="#a86400" class="mr-2">mdi-file-document-outline</v-icon>
                ข้อมูลคำสั่ง
              </div>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editpersonnel_duty.personnel_dutyYear"
                    label="ปี พ.ศ."
                    type="number"
                    :rules="[
                      v => !!v || 'กรุณาระบุปี',
                      v => (v && String(v).length === 4) || 'ปีต้องเป็นตัวเลข 4 หลัก'
                    ]"
                    outlined
                    dense
                    prepend-inner-icon="mdi-calendar"
                    class="modern-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editpersonnel_duty.personnel_dutyOrderID"
                    label="เลขที่คำสั่ง"
                    :rules="[v => !!v || 'กรุณาระบุเลขที่คำสั่ง']"
                    outlined
                    dense
                    prepend-inner-icon="mdi-file-sign"
                    class="modern-input"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>

            <!-- Section: รายละเอียด -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="#455a64" class="mr-2">mdi-text-box-outline</v-icon>
                รายละเอียดโครงการ/กิจกรรม
              </div>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="editpersonnel_duty.personnel_dutyTopic"
                    label="ชื่อโครงการ/กิจกรรมในสถานศึกษา"
                    :rules="[v => !!v || 'กรุณาระบุชื่อโครงการ/กิจกรรม']"
                    outlined
                    rows="3"
                    auto-grow
                    prepend-inner-icon="mdi-text"
                    class="modern-input"
                  ></v-textarea>
                </v-col>
              </v-row>
            </div>

            <!-- Section: วันที่ -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="#2e7d32" class="mr-2">mdi-calendar-range</v-icon>
                วันที่ดำเนินการ
              </div>
              <v-row>
                <v-col cols="12">
                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="editpersonnel_duty.personnel_dutyDateTime"
                        label="วันที่เริ่มดำเนินการ"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        class="modern-input"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="editpersonnel_duty.personnel_dutyDateTime"
                      no-title
                      scrollable
                      locale="th-TH"
                      color="#a86400"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="grey" @click="menu2 = false">ยกเลิก</v-btn>
                      <v-btn text color="#a86400" @click="$refs.menu2.save(date)">ตกลง</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </div>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text large @click="editpersonnel_dutydialog = false" class="cancel-btn">
            <v-icon left>mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            large
            depressed
            color="#a86400"
            dark
            @click="editpersonnel_dutySubmit()"
            class="save-btn"
          >
            <v-icon left>mdi-content-save-outline</v-icon>
            บันทึกการแก้ไข
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Confirmation Dialog -->
    <v-dialog
      v-model="deletepersonnel_dutydialog"
      persistent
      max-width="480px"
      content-class="modern-dialog"
    >
      <v-card class="dialog-card delete-dialog">
        <v-card-title class="dialog-header delete-header">
          <v-icon class="mr-3" color="white" size="28">mdi-delete-alert-outline</v-icon>
          <span>ยืนยันการลบข้อมูล</span>
        </v-card-title>

        <v-card-text class="delete-content text-center">
          <v-form ref="deletepersonnel_dutyform" lazy-validation>
            <div class="delete-icon-wrapper">
              <v-icon size="72" color="#dc2626">mdi-alert-circle-outline</v-icon>
            </div>
            <div class="delete-message">คุณต้องการลบรายการนี้หรือไม่?</div>
            
            <v-card class="delete-info-card mt-4" outlined>
              <v-card-text class="pa-4">
                <div class="delete-info-row">
                  <span class="info-label">คำสั่งที่:</span>
                  <v-chip small color="#fef2f2" text-color="#dc2626">
                    {{ editpersonnel_duty.personnel_dutyOrderID }}
                  </v-chip>
                </div>
                <div class="delete-info-topic mt-3">
                  <span class="info-label">เรื่อง:</span>
                  <p class="info-value">{{ editpersonnel_duty.personnel_dutyTopic }}</p>
                </div>
              </v-card-text>
            </v-card>

            <div class="delete-warning mt-4">
              <v-icon small color="#a86400" class="mr-1">mdi-alert</v-icon>
              การดำเนินการนี้ไม่สามารถย้อนกลับได้
            </div>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text large @click="deletepersonnel_dutydialog = false" class="cancel-btn">
            <v-icon left>mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            large
            depressed
            color="#dc2626"
            dark
            @click="deletepersonnel_dutyubmit()"
            class="delete-confirm-btn"
          >
            <v-icon left>mdi-delete-outline</v-icon>
            ลบข้อมูล
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      top
      right
      class="modern-snackbar"
    >
      <div class="d-flex align-center">
        <v-icon class="mr-3" color="white">{{ snackbar.icon }}</v-icon>
        <span>{{ snackbar.text }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">ปิด</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: 'PersonnelDuty',

  data() {
    return {
      ApiKey: 'HRvec2021',
      loading: true,
      search: '',
      addpersonnel_dutydialog: false,
      editpersonnel_dutydialog: false,
      deletepersonnel_dutydialog: false,
      snackbar: {
        show: false,
        color: '',
        timeout: 4000,
        icon: '',
        text: ''
      },
      headers: [
        { text: '#', align: 'center', value: 'index', width: '60px', sortable: false },
        { text: 'สถานศึกษา', align: 'left', value: 'college_name' },
        { text: 'ปี พ.ศ.', align: 'center', value: 'personnel_dutyYear', width: '120px' },
        { text: 'คำสั่งที่', align: 'left', value: 'personnel_dutyOrderID', width: '140px' },
        { text: 'ชื่อโครงการ/กิจกรรม', align: 'left', value: 'personnel_dutyTopic' },
        { text: 'วันที่', align: 'center', value: 'personnel_dutyDateTime', width: '140px' },
        { text: 'จัดการ', align: 'center', value: 'actions', sortable: false, width: '120px' }
      ],
      personnel_dutys: [],
      addpersonnel_duty: {},
      editpersonnel_duty: {},
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      menu2: false
    }
  },

  computed: {
    countCurrentYear() {
      const currentYear = new Date().getFullYear() + 543
      return this.personnel_dutys.filter(
        item => String(item.personnel_dutyYear) === String(currentYear)
      ).length
    },
    uniqueColleges() {
      const colleges = new Set(this.personnel_dutys.map(item => item.college_name))
      return colleges.size
    },
    uniqueYears() {
      const years = new Set(this.personnel_dutys.map(item => item.personnel_dutyYear))
      return years.size
    }
  },

  async mounted() {
    await this.personnel_dutysQueryAll()
  },

  methods: {
    async personnel_dutysQueryAll() {
      this.loading = true
      let userSession = JSON.parse(localStorage.getItem('user')) || 0
      let result = await this.$http
        .post('personnel_duty.php', {
          ApiKey: this.ApiKey,
          personnel_dutyIDCard: userSession.id_card
        })
        .finally(() => (this.loading = false))
      this.personnel_dutys = result.data
    },

    // Add operations
    personnel_dutyAdd() {
      this.addpersonnel_duty = {}
      this.addpersonnel_dutydialog = true
    },

    async addpersonnel_dutySubmit() {
      if (this.$refs.addpersonnel_dutyform.validate()) {
        let userSession = JSON.parse(localStorage.getItem('user')) || 0
        this.addpersonnel_duty.ApiKey = this.ApiKey
        this.addpersonnel_duty.personnel_dutyIDCard = userSession.id_card
        this.addpersonnel_duty.personnel_dutyCollege = userSession.college_code

        let result = await this.$http.post(
          'personnel_duty.insert.php',
          this.addpersonnel_duty
        )

        if (result.data.status === true) {
          Swal.fire({
            icon: 'success',
            title: 'บันทึกสำเร็จ',
            text: 'เพิ่มรายการปฏิบัติหน้าที่เรียบร้อยแล้ว',
            showConfirmButton: false,
            timer: 1500
          })
          this.personnel_dutysQueryAll()
        } else {
          Swal.fire({
            icon: 'error',
            title: 'เกิดข้อผิดพลาด',
            text: 'ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง',
            showConfirmButton: true
          })
        }
        this.addpersonnel_dutydialog = false
      }
    },

    // Edit operations
    async personnel_dutyEdit(personnel_dutyID) {
      let result = await this.$http.post('personnel_duty.php', {
        ApiKey: this.ApiKey,
        personnel_dutyID: personnel_dutyID
      })
      this.editpersonnel_duty = result.data
      this.editpersonnel_dutydialog = true
    },

    async editpersonnel_dutySubmit() {
      if (this.$refs.editpersonnel_dutyform.validate()) {
        this.editpersonnel_duty.ApiKey = this.ApiKey

        let result = await this.$http.post(
          'personnel_duty.update.php',
          this.editpersonnel_duty
        )

        if (result.data.status === true) {
          Swal.fire({
            icon: 'success',
            title: 'แก้ไขสำเร็จ',
            text: 'อัปเดตรายการปฏิบัติหน้าที่เรียบร้อยแล้ว',
            showConfirmButton: false,
            timer: 1500
          })
          this.personnel_dutysQueryAll()
        } else {
          Swal.fire({
            icon: 'error',
            title: 'เกิดข้อผิดพลาด',
            text: 'ไม่สามารถแก้ไขข้อมูลได้ กรุณาลองใหม่อีกครั้ง',
            showConfirmButton: true
          })
        }
        this.editpersonnel_dutydialog = false
      }
    },

    // Delete operations
    async personnel_dutyDelete(personnel_dutyID) {
      let result = await this.$http.post('personnel_duty.php', {
        ApiKey: this.ApiKey,
        personnel_dutyID: personnel_dutyID
      })
      this.editpersonnel_duty = result.data
      this.deletepersonnel_dutydialog = true
    },

    async deletepersonnel_dutyubmit() {
      this.editpersonnel_duty.ApiKey = this.ApiKey

      let result = await this.$http.post(
        'personnel_duty.delete.php',
        this.editpersonnel_duty
      )

      if (result.data.status === true) {
        Swal.fire({
          icon: 'success',
          title: 'ลบสำเร็จ',
          text: 'ลบรายการปฏิบัติหน้าที่เรียบร้อยแล้ว',
          showConfirmButton: false,
          timer: 1500
        })
        this.personnel_dutysQueryAll()
      } else {
        Swal.fire({
          icon: 'error',
          title: 'เกิดข้อผิดพลาด',
          text: 'ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง',
          showConfirmButton: true
        })
      }
      this.deletepersonnel_dutydialog = false
    }
  }
}
</script>

<style scoped>
/* Import Google Font */
@import url('https://fonts.googleapis.com/css2?family=Prompt:wght@300;400;500;600;700&display=swap');

.personnel-duty-container {
  font-family: 'Prompt', sans-serif;
  padding: 24px;
  background: linear-gradient(180deg, #fafafa 0%, #f5f5f5 100%);
  min-height: 100vh;
}

/* Hero Header */
.hero-header {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 50%, #991b1b 100%);
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 10px 40px rgba(220, 38, 38, 0.3);
}

.hero-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23ffffff' fill-opacity='0.05' fill-rule='evenodd'/%3E%3C/svg%3E");
}

.hero-content {
  display: flex;
  align-items: center;
  padding: 32px;
  position: relative;
  z-index: 1;
}

.hero-icon-wrapper {
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 24px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.hero-text {
  color: white;
}

.hero-title {
  font-size: 26px;
  font-weight: 600;
  margin: 0 0 6px 0;
  letter-spacing: -0.3px;
}

.hero-subtitle {
  font-size: 14px;
  opacity: 0.9;
  margin: 0;
  font-weight: 300;
}

.add-btn {
  background: white !important;
  color: #dc2626 !important;
  font-weight: 500;
  border-radius: 12px;
  padding: 0 28px !important;
  text-transform: none;
  letter-spacing: 0;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.add-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

/* Statistics Cards */
.stats-row {
  margin-top: -16px;
}

.stat-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.04);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.08);
}

.stat-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-card-1 .stat-icon { background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%); }
.stat-card-2 .stat-icon { background: linear-gradient(135deg, #a86400 0%, #a86400 100%); }
.stat-card-3 .stat-icon { background: linear-gradient(135deg, #455a64 0%, #455a64 100%); }
.stat-card-4 .stat-icon { background: linear-gradient(135deg, #2e7d32 0%, #1b5e20 100%); }

.stat-content {
  display: flex;
  flex-direction: column;
}

.stat-number {
  font-size: 28px;
  font-weight: 700;
  color: #263238;
  line-height: 1;
}

.stat-label {
  font-size: 13px;
  color: #6b7280;
  margin-top: 4px;
  font-weight: 400;
}

/* Main Table Card */
.main-table-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.04);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
}

.table-header {
  padding: 20px 24px;
  background: #fafafa;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  color: #263238;
}

.search-field {
  background: white;
}

.search-field >>> .v-input__slot {
  border-radius: 12px !important;
}

/* Data Table Styles */
.modern-table {
  font-family: 'Prompt', sans-serif;
}

.modern-table >>> thead th {
  background: #fef2f2 !important;
  color: #991b1b !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  border-bottom: 2px solid #fecaca !important;
  padding: 16px 12px !important;
}

.table-row {
  transition: all 0.2s ease;
}

.table-row:hover {
  background: #fffbfb !important;
}

.table-row td {
  padding: 16px 12px !important;
  border-bottom: 1px solid #f3f4f6 !important;
  font-size: 14px;
  color: #374151;
}

.college-cell {
  display: flex;
  align-items: center;
  font-weight: 500;
}

.year-chip {
  font-weight: 600;
}

.order-chip {
  font-weight: 500;
}

.topic-cell {
  max-width: 300px;
}

.topic-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.5;
}

/* Action Buttons */
.action-btn {
  width: 34px !important;
  height: 34px !important;
  transition: all 0.2s ease;
}

.edit-btn {
  background: #fff4dc !important;
  color: #a86400 !important;
}

.edit-btn:hover {
  background: #fff4dc !important;
  transform: scale(1.1);
}

.delete-btn {
  background: #fef2f2 !important;
  color: #dc2626 !important;
}

.delete-btn:hover {
  background: #fecaca !important;
  transform: scale(1.1);
}

/* Dialog Styles */
.modern-dialog {
  border-radius: 20px !important;
  overflow: hidden;
}

.dialog-card {
  border-radius: 20px !important;
  overflow: hidden;
}

.dialog-header {
  padding: 20px 24px;
  font-size: 18px;
  font-weight: 600;
}

.add-header {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  color: white;
}

.edit-header {
  background: linear-gradient(135deg, #a86400 0%, #a86400 100%);
  color: white;
}

.delete-header {
  background: linear-gradient(135deg, #dc2626 0%, #991b1b 100%);
  color: white;
}

.dialog-content {
  padding: 24px !important;
  max-height: 65vh;
  overflow-y: auto;
}

.form-section {
  background: #fafafa;
  border-radius: 14px;
  padding: 20px;
  margin-bottom: 16px;
  border: 1px solid #f3f4f6;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #263238;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

.modern-input >>> .v-input__slot {
  background: white !important;
  border-radius: 10px !important;
}

.dialog-actions {
  padding: 16px 24px;
  background: #fafafa;
}

.cancel-btn {
  color: #6b7280 !important;
  font-weight: 500;
  text-transform: none;
}

.save-btn {
  border-radius: 10px;
  font-weight: 500;
  text-transform: none;
  padding: 0 24px !important;
}

/* Delete Dialog */
.delete-content {
  padding: 32px 24px !important;
}

.delete-icon-wrapper {
  margin-bottom: 16px;
}

.delete-message {
  font-size: 18px;
  font-weight: 500;
  color: #263238;
}

.delete-info-card {
  background: #fafafa;
  border-radius: 12px !important;
  border-color: #e5e7eb !important;
}

.delete-info-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.info-label {
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
}

.delete-info-topic {
  text-align: left;
}

.info-value {
  font-size: 14px;
  color: #374151;
  margin: 6px 0 0 0;
  line-height: 1.5;
}

.delete-warning {
  font-size: 13px;
  color: #a86400;
}

.delete-confirm-btn {
  border-radius: 10px;
  font-weight: 500;
  text-transform: none;
}

/* Snackbar */
.modern-snackbar >>> .v-snack__wrapper {
  border-radius: 12px;
  font-family: 'Prompt', sans-serif;
}

/* Responsive */
@media (max-width: 960px) {
  .hero-content {
    flex-wrap: wrap;
    gap: 16px;
  }

  .hero-icon-wrapper {
    width: 64px;
    height: 64px;
    margin-right: 16px;
  }

  .hero-title {
    font-size: 20px;
  }

  .add-btn {
    width: 100%;
    margin-top: 16px;
  }
}

@media (max-width: 600px) {
  .personnel-duty-container {
    padding: 16px;
  }

  .hero-content {
    padding: 20px;
  }

  .stat-card {
    padding: 16px;
  }

  .stat-number {
    font-size: 24px;
  }

  .topic-cell {
    max-width: 150px;
  }
}

/* Animation */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.stat-card {
  animation: fadeInUp 0.5s ease forwards;
  opacity: 0;
}

.stat-card:nth-child(1) { animation-delay: 0.1s; }
.stat-card:nth-child(2) { animation-delay: 0.2s; }
.stat-card:nth-child(3) { animation-delay: 0.3s; }
.stat-card:nth-child(4) { animation-delay: 0.4s; }

/* Custom scrollbar */
.dialog-content::-webkit-scrollbar {
  width: 6px;
}

.dialog-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb:hover {
  background: #ccc;
}
</style>